export const __DEV__ = process.env.REACT_APP_ENV === "development";
export const CUSTOM_CONFIG_NAME = process.env.REACT_APP_CUSTOM_CONFIG_NAME;
export const USE_CURRENT_HOST = process.env.REACT_APP_USE_CURRENT_HOST;
